/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import type { FieldStore } from "@formisch/react"

/**
 * Shows an error only after the field has been edited.
 *
 * Form validation runs on blur and can populate errors for untouched fields;
 * `isEdited` keeps those errors hidden until the user interacts with the field.
 */
export const isFieldInvalid = (field: Pick<FieldStore, "errors" | "isEdited">) => field.isEdited && !!field.errors
